import request from '../util/request'
class MonitorService {
    constructor() {
        this.baseUrl = "/appconfig/t/appconfig";
    }
    getApkList(params) {
        return request.get(this.baseUrl, { params });
    }
}
export default new MonitorService();
